module.exports = __webpack_public_path__ + "static/media/rgs_plus_phone_holder.e71e4952.png";